import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {Navigate} from 'react-router-dom';
import {Role} from '../../incase-domain/user';
import {useLoggedInUser} from '../../ui/pages/auth/queries';
import {loggedInUserSelector} from '../../store/selectors/auth.selectors';

export function UserProtectedRoute({children}: {children: React.ReactElement}): React.ReactElement {
    const loggedInUser = useSelector(loggedInUserSelector);
    const forbiddenRoles = useMemo(() => [Role.PRESENTER, Role.VIEWER], []);
    const {isFetched} = useLoggedInUser();

    if (!loggedInUser && isFetched) {
        return <Navigate to="/login" replace />;
    }

    if (loggedInUser?.roles.some((role) => forbiddenRoles.includes(role))) {
        return <Navigate to="/login" replace />;
    }

    return <>{loggedInUser ? children : <div />}</>;
}
